module.exports = __webpack_public_path__ + "img/album08_03.eeea1732.jpg";